const env =
  window.location.hostname === "www.one.com"
    ? "production"
    : window.location.hostname;

export default {
  app: "domain-search",
  url: "https://aec.one.com/",
  env,
};
